import React, {
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useSpring, animated, to } from "react-spring";
import { useGesture } from "react-use-gesture";
import { ContainerPlanta, ContainerPlantaTitulo, PlantaLink } from "./styled";

const OpenedImagePlantas = (
  {
    setupCarouselPlantas,
    imagesListPlantas,
    imageClosedPlantas,
    setImageClosedPlantas,
    openLink,
  },
  ref
) => {
  // Derive the current planta (and its floor image) straight from currentSlide
  // during render. Keeping this as lagged state (updated in a useEffect) made
  // the image trail the legend by one slide → they appeared offset by one.
  const currentPlanta = imagesListPlantas[setupCarouselPlantas.currentSlide];
  const floorImage = currentPlanta
    ? setupCarouselPlantas.floor === "inferior"
      ? currentPlanta.url
      : currentPlanta.url2
    : "";
  const calcX = (y, ly) => -(y - ly - window.innerHeight / 2) / 20;
  const calcY = (x, lx) => (x - lx - window.innerWidth / 2) / 20;

  const domTarget = React.useRef(null);
  const [{ x, y, rotateX, rotateY, rotateZ, zoom, scale }, set] = useSpring(
    () => ({
      rotateX: 0,
      rotateY: 0,
      rotateZ: 0,
      scale: 1,
      zoom: 0,
      x: 0,
      y: 0,
      config: { mass: 5, tension: 350, friction: 40 },
    })
  );

  const [lastOffset, setLastOffset] = useState([0, 0]);

  const [drag, setDrag] = React.useState(false);

  useImperativeHandle(
    ref,
    () => ({
      setFromOutside(msg) {
        set(msg);
      },
    }),
    []
  );

  useGesture(
    {
      onDragStart: ({ offset }) => {
        if (imageClosedPlantas) {
          if (lastOffset[0] !== offset[0] && lastOffset[1] !== offset[1]) {
            setImageClosedPlantas(false);
          }
        }
      },
      onDrag: ({ offset }) => {
        if (!imageClosedPlantas) {
          setDrag(true);
          set({ x: offset[0], y: offset[1], rotateX: 0, rotateY: 0, scale: 1 });
        }
      },
      onDragEnd: ({ offset }) => {
        setDrag(false);
        if (!imageClosedPlantas) {
          setLastOffset(offset);
        } else {
          offset[0] = 0;
          offset[1] = 0;
        }
      },
      onPinch: ({ offset: [d, a] }) => set({ zoom: d / 1000 }),
      // onMove: ({ xy: [px, py], dragging }) =>
      //   !dragging &&
      //   set({
      //     rotateX: calcX(py, y.get()),
      //     rotateY: calcY(px, x.get()),
      //     scale: 1.1,
      //   }),
      onHover: ({ hovering }) =>
        !hovering && set({ rotateX: 0, rotateY: 0, scale: 1 }),
    },

    { domTarget, eventOptions: { passive: false } }
  );

  return (
    <ContainerPlanta>
      <animated.div
        ref={domTarget}
        className={`${drag ? "dragging" : ""}`}
        style={{
          width: "1920px",
          height: "1080px",
          backgroundImage: `url(${floorImage})`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
          transform: "perspective(600px)",
          x,
          y,
          scale: to([scale, zoom], (s, z) => s + z),
        }}
      ></animated.div>
      {/* Legend/link sit OUTSIDE the animated div so they stay fixed to the
          window corners and don't zoom/pan with the floor plan. */}
      <ContainerPlantaTitulo>
        {currentPlanta !== undefined ? currentPlanta.text : ""}
      </ContainerPlantaTitulo>
      {currentPlanta && currentPlanta.link ? (
        <PlantaLink
          title="Abrir link desta planta"
          onClick={(e) => {
            e.stopPropagation();
            openLink(currentPlanta.link);
          }}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
        </PlantaLink>
      ) : null}
    </ContainerPlanta>
  );
};

export default forwardRef(OpenedImagePlantas);
